import type { FC } from "react";

import { Table } from "@/components/ui/table";
import { cn } from "@/lib/utils";

import type { TableProps } from "./types";

const TableOver: FC<TableProps> = ({ children, classes }) => {
  return (
    <Table
      className={cn(
        "border-separate border-spacing-0 rounded-md overflow-hidden border border-gray-200 rounded-[8px]",
        classes
      )}
    >
      {children}
    </Table>
  );
};

export default TableOver;
